define('collections/pixelBundleUrls',["jQuery", "T1", "T1Collection", "models/pixelBundleUrl"], function ($, T1, T1Collection, PixelBundleUrl) {
  T1.Models.PixelBundleUrls = T1Collection.extend({
    model: PixelBundleUrl,
    urlString: "pixel_bundle_urls"
  });
  return T1.Models.PixelBundleUrls;
});
